(function() {
  'use strict';

  var STORAGE_KEY = 'soshiotsuki_favorites';
  var BUTTON_SELECTOR = '[data-favorite-toggle]';
  var CHANGE_EVENT = 'soshiotsuki:favorites-changed';
  var SAVED_VIEW_EVENT = 'soshiotsuki:saved-view-open';
  var cartRenderId = 0;
  var drawerRenderId = 0;
  var productCache = {};

  function normalizeFavorites(value) {
    if (!Array.isArray(value)) {
      return [];
    }

    return value.reduce(function(favorites, handle) {
      if (
        typeof handle === 'string' &&
        handle.length > 0 &&
        favorites.indexOf(handle) === -1
      ) {
        favorites.push(handle);
      }

      return favorites;
    }, []);
  }

  function getFavorites() {
    try {
      return normalizeFavorites(
        JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]')
      );
    } catch (error) {
      return [];
    }
  }

  function saveFavorites(favorites) {
    var normalizedFavorites = normalizeFavorites(favorites);

    try {
      window.localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify(normalizedFavorites)
      );
    } catch (error) {
      // Keep the controls usable without interrupting the rest of the theme.
    }

    return normalizedFavorites;
  }

  function updateButton(button, favorites) {
    var handle = button.getAttribute('data-product-handle');
    var isFavorite = favorites.indexOf(handle) !== -1;
    var icon = button.querySelector('[data-favorite-icon]');
    var iconSource = isFavorite
      ? button.getAttribute('data-favorite-filled-src')
      : button.getAttribute('data-favorite-outline-src');

    button.classList.toggle('is-favorite', isFavorite);
    button.setAttribute('aria-pressed', isFavorite ? 'true' : 'false');
    button.setAttribute(
      'aria-label',
      isFavorite ? 'Remove from favorites' : 'Add to favorites'
    );

    if (icon && iconSource) {
      icon.setAttribute('src', iconSource);
    }
  }

  function updateButtons(favorites) {
    var currentFavorites = favorites || getFavorites();

    Array.prototype.forEach.call(
      document.querySelectorAll(BUTTON_SELECTOR),
      function(button) {
        updateButton(button, currentFavorites);
      }
    );
  }

  function updateHeaderFavoriteCount(favorites) {
    var count = normalizeFavorites(favorites || getFavorites()).length;

    Array.prototype.forEach.call(
      document.querySelectorAll('[data-header-favorites-count]'),
      function(element) {
        element.textContent = String(count);
        element.classList.toggle(
          'site-header__favorites-count--hidden',
          count === 0
        );
        element.setAttribute('aria-hidden', count === 0 ? 'true' : 'false');
      }
    );
  }

  function announceChange(favorites) {
    document.dispatchEvent(
      new CustomEvent(CHANGE_EVENT, {
        detail: { favorites: favorites }
      })
    );
  }

  function toggleFavorite(handle) {
    var favorites = getFavorites();
    var favoriteIndex = favorites.indexOf(handle);

    if (favoriteIndex === -1) {
      favorites.push(handle);
    } else {
      favorites.splice(favoriteIndex, 1);
    }

    favorites = saveFavorites(favorites);
    announceChange(favorites);
  }

  function getProductImage(product) {
    if (!product || !product.featured_image) {
      return '';
    }

    if (typeof product.featured_image === 'string') {
      return product.featured_image;
    }

    return product.featured_image.src || '';
  }

  function getRootUrl(section) {
    var rootUrl = section.getAttribute('data-root-url') || '/';
    return rootUrl.replace(/\/?$/, '/');
  }

  function fetchProductComingSoon(handle, rootUrl) {
    return window
      .fetch(
        rootUrl +
          'products/' +
          encodeURIComponent(handle) +
          '?view=saved-status',
        {
          credentials: 'same-origin',
          headers: { Accept: 'text/html' }
        }
      )
      .then(function(response) {
        if (!response.ok) {
          throw new Error('Unable to load saved product status.');
        }

        return response.json();
      })
      .then(function(status) {
        return !!(status && status.coming_soon === true);
      })
      .catch(function() {
        // Fail closed so a missing status endpoint never enables purchase.
        return true;
      });
  }

  function fetchProduct(handle, rootUrl) {
    if (Object.prototype.hasOwnProperty.call(productCache, handle)) {
      return Promise.resolve(productCache[handle]);
    }

    var productRequest = window
      .fetch(rootUrl + 'products/' + encodeURIComponent(handle) + '.js', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      })
      .then(function(response) {
        if (!response.ok) {
          return null;
        }

        return response.json();
      });

    return Promise.all([
      productRequest,
      fetchProductComingSoon(handle, rootUrl)
    ])
      .then(function(results) {
        var product = results[0];

        if (product) {
          product.soshiotsukiComingSoon = results[1];
        }

        productCache[handle] = product;
        return product;
      })
      .catch(function() {
        productCache[handle] = null;
        return null;
      });
  }

  function formatMoney(cents, moneyFormat) {
    if (
      window.Shopify &&
      typeof window.Shopify.formatMoney === 'function'
    ) {
      return window.Shopify.formatMoney(cents, moneyFormat);
    }

    if (
      window.Intl &&
      window.Shopify &&
      window.Shopify.currency &&
      window.Shopify.currency.active
    ) {
      return new Intl.NumberFormat(
        document.documentElement.lang || undefined,
        {
          style: 'currency',
          currency: window.Shopify.currency.active
        }
      ).format((Number(cents) || 0) / 100);
    }

    return String((Number(cents) || 0) / 100);
  }

  function buildFavoriteButton(handle, section, modifier) {
    var button = document.createElement('button');
    var icon = document.createElement('img');

    button.type = 'button';
    button.className = 'favorite-button favorite-button--' + modifier;
    button.setAttribute('data-favorite-toggle', '');
    button.setAttribute('data-product-handle', handle);
    button.setAttribute(
      'data-favorite-outline-src',
      section.getAttribute('data-favorite-outline-src')
    );
    button.setAttribute(
      'data-favorite-filled-src',
      section.getAttribute('data-favorite-filled-src')
    );

    icon.className = 'favorite-button__icon';
    icon.setAttribute('data-favorite-icon', '');
    icon.setAttribute('alt', '');
    icon.setAttribute('width', '24');
    icon.setAttribute('height', '24');
    icon.setAttribute('aria-hidden', 'true');
    button.appendChild(icon);

    return button;
  }

  function buildCartFavoriteItem(
    product,
    section,
    rootUrl,
    moneyFormat,
    favorites
  ) {
    var item = document.createElement('article');
    var media = document.createElement('div');
    var imageLink = document.createElement('a');
    var details = document.createElement('div');
    var meta = document.createElement('div');
    var titleLink = document.createElement('a');
    var price = document.createElement('div');
    var options = document.createElement('div');
    var addButton = document.createElement('button');
    var status = document.createElement('p');
    var productUrl =
      product.url || rootUrl + 'products/' + product.handle;
    var imageSource = getProductImage(product);
    var optionDefinitions = getProductOptions(product);
    var variants = Array.isArray(product.variants) ? product.variants : [];
    var defaultVariant =
      variants.filter(function(variant) {
        return variant.available;
      })[0] || variants[0];
    var defaultOptions = getVariantOptions(
      defaultVariant,
      optionDefinitions.length
    );

    item.className = 'favorites-section__item';
    item.setAttribute('data-saved-item', '');

    media.className = 'favorites-section__media';
    imageLink.className = 'favorites-section__image-link';
    imageLink.href = productUrl;
    imageLink.setAttribute('aria-label', product.title || product.handle);

    if (imageSource) {
      var image = document.createElement('img');
      image.className = 'favorites-section__image';
      image.src = imageSource;
      image.alt = product.title || '';
      image.loading = 'lazy';
      imageLink.appendChild(image);
    }

    details.className = 'favorites-section__details';
    meta.className = 'favorites-section__meta';
    titleLink.className = 'favorites-section__title';
    titleLink.href = productUrl;
    titleLink.textContent = product.title || product.handle;

    price.className = 'favorites-section__price';
    price.setAttribute('data-saved-price', '');

    meta.appendChild(titleLink);
    meta.appendChild(price);

    options.className = 'favorites-section__options';

    optionDefinitions.forEach(function(definition, optionIndex) {
      var label = document.createElement('label');
      var labelText = document.createElement('span');
      var select = document.createElement('select');

      label.className = 'favorites-section__option';
      labelText.textContent = definition.name + ':';
      select.setAttribute('data-saved-option-index', String(optionIndex));
      select.setAttribute(
        'aria-label',
        (product.title || product.handle) + ' ' + definition.name
      );

      definition.values.forEach(function(value) {
        var option = document.createElement('option');
        option.value = value;
        option.textContent = value;
        option.selected = defaultOptions[optionIndex] === value;
        select.appendChild(option);
      });

      label.appendChild(labelText);
      label.appendChild(select);
      options.appendChild(label);
    });

    addButton.type = 'button';
    addButton.className = 'favorites-section__add';
    addButton.setAttribute('data-saved-add', '');

    status.className = 'favorites-section__status';
    status.setAttribute('data-saved-status', '');
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');

    details.appendChild(meta);
    details.appendChild(options);
    details.appendChild(addButton);
    details.appendChild(status);

    var button = buildFavoriteButton(product.handle, section, 'cart');
    updateButton(button, favorites);
    media.appendChild(imageLink);
    media.appendChild(button);
    item.appendChild(media);
    item.appendChild(details);

    Array.prototype.forEach.call(
      options.querySelectorAll('select'),
      function(select) {
        select.addEventListener('change', function() {
          updateSavedVariant(item, product, moneyFormat);
        });
      }
    );

    updateSavedVariant(item, product, moneyFormat);

    return item;
  }

  function isStandaloneSavedView(section) {
    return (
      section &&
      section.id === 'FavoritesSection' &&
      window.location.hash === '#FavoritesSection'
    );
  }

  function renderEmptySavedView(section, list) {
    var empty = document.createElement('p');
    empty.className = 'favorites-section__empty';
    empty.textContent = 'No saved items.';
    list.appendChild(empty);
    section.hidden = false;
  }

  function renderCartFavorites(favorites) {
    var section = document.querySelector('[data-favorites-section]');

    if (!section) {
      return;
    }

    var currentRenderId = ++cartRenderId;
    var currentFavorites = normalizeFavorites(favorites || getFavorites());
    var list = section.querySelector('[data-favorites-list]');
    var rootUrl = getRootUrl(section);
    var moneyFormat =
      section.getAttribute('data-money-format') || '${{amount}}';
    var standaloneView = isStandaloneSavedView(section);

    list.innerHTML = '';
    section.hidden = true;

    if (currentFavorites.length === 0) {
      if (standaloneView) {
        renderEmptySavedView(section, list);
      }
      return;
    }

    Promise.all(
      currentFavorites.map(function(handle) {
        return fetchProduct(handle, rootUrl);
      })
    ).then(function(products) {
      if (currentRenderId !== cartRenderId) {
        return;
      }

      products
        .filter(function(product) {
          return product && product.handle;
        })
        .forEach(function(product) {
          list.appendChild(
            buildCartFavoriteItem(
              product,
              section,
              rootUrl,
              moneyFormat,
              currentFavorites
            )
          );
        });

      if (list.children.length === 0 && standaloneView) {
        renderEmptySavedView(section, list);
      } else {
        section.hidden = list.children.length === 0;
      }
    });
  }

  function getVariantOptions(variant, optionCount) {
    var values = Array.isArray(variant && variant.options)
      ? variant.options.slice(0, optionCount)
      : [];
    var index;

    for (index = values.length; index < optionCount; index += 1) {
      values.push((variant && variant['option' + (index + 1)]) || '');
    }

    return values;
  }

  function getProductOptions(product) {
    var variants = Array.isArray(product.variants) ? product.variants : [];
    var rawOptions = Array.isArray(product.options) ? product.options : [];

    return rawOptions.map(function(option, optionIndex) {
      var name =
        typeof option === 'string'
          ? option
          : option && option.name
            ? option.name
            : 'Option ' + (optionIndex + 1);
      var values =
        option && Array.isArray(option.values) ? option.values.slice() : [];

      variants.forEach(function(variant) {
        var value = getVariantOptions(
          variant,
          rawOptions.length
        )[optionIndex];

        if (value && values.indexOf(value) === -1) {
          values.push(value);
        }
      });

      return {
        name: name,
        values: values
      };
    });
  }

  function updateSavedVariant(item, product, moneyFormat) {
    var selects = item.querySelectorAll('[data-saved-option-index]');
    var selectedOptions = Array.prototype.map.call(
      selects,
      function(select) {
        return select.value;
      }
    );
    var variants = Array.isArray(product.variants) ? product.variants : [];
    var variant =
      selectedOptions.length === 0
        ? variants.filter(function(candidate) {
            return candidate.available;
          })[0] || variants[0]
        : variants.filter(function(candidate) {
            var candidateOptions = getVariantOptions(
              candidate,
              selectedOptions.length
            );

            return selectedOptions.every(function(value, index) {
              return candidateOptions[index] === value;
            });
          })[0];
    var addButton = item.querySelector('[data-saved-add]');
    var price = item.querySelector('[data-saved-price]');
    var comingSoon = product.soshiotsukiComingSoon === true;
    var available = !!(variant && variant.available) && !comingSoon;

    if (price) {
      price.innerHTML = formatMoney(
        variant && variant.price != null ? variant.price : product.price,
        moneyFormat
      );
    }

    if (!addButton) {
      return;
    }

    addButton.setAttribute(
      'data-variant-id',
      variant && variant.id ? String(variant.id) : ''
    );
    addButton.setAttribute(
      'data-coming-soon',
      comingSoon ? 'true' : 'false'
    );
    addButton.disabled = !available;
    addButton.textContent = comingSoon
      ? 'COMING SOON'
      : available
        ? 'ADD TO BAG'
        : 'UNAVAILABLE';
  }

  function buildSavedDrawerItem(
    product,
    drawer,
    rootUrl,
    moneyFormat,
    favorites
  ) {
    var item = document.createElement('article');
    var media = document.createElement('div');
    var imageLink = document.createElement('a');
    var info = document.createElement('div');
    var titleLink = document.createElement('a');
    var price = document.createElement('p');
    var options = document.createElement('div');
    var addButton = document.createElement('button');
    var status = document.createElement('p');
    var imageSource = getProductImage(product);
    var productUrl =
      product.url || rootUrl + 'products/' + product.handle;
    var optionDefinitions = getProductOptions(product);
    var variants = Array.isArray(product.variants) ? product.variants : [];
    var defaultVariant =
      variants.filter(function(variant) {
        return variant.available;
      })[0] || variants[0];
    var defaultOptions = getVariantOptions(
      defaultVariant,
      optionDefinitions.length
    );

    item.className = 'cart-drawer__saved-item';
    item.setAttribute('data-saved-item', '');

    media.className = 'cart-drawer__saved-media';
    imageLink.className = 'cart-drawer__saved-image-link';
    imageLink.href = productUrl;
    imageLink.setAttribute('aria-label', product.title || product.handle);

    if (imageSource) {
      var image = document.createElement('img');
      image.className = 'cart-drawer__saved-image';
      image.src = imageSource;
      image.alt = product.title || '';
      image.loading = 'lazy';
      imageLink.appendChild(image);
    }

    media.appendChild(imageLink);

    var favoriteButton = buildFavoriteButton(
      product.handle,
      drawer,
      'drawer'
    );
    updateButton(favoriteButton, favorites);
    media.appendChild(favoriteButton);

    info.className = 'cart-drawer__saved-info';
    titleLink.className = 'cart-drawer__saved-title';
    titleLink.href = productUrl;
    titleLink.textContent = product.title || product.handle;

    price.className = 'cart-drawer__saved-price';
    price.setAttribute('data-saved-price', '');

    options.className = 'cart-drawer__saved-options';

    optionDefinitions.forEach(function(definition, optionIndex) {
      var label = document.createElement('label');
      var labelText = document.createElement('span');
      var select = document.createElement('select');

      label.className = 'cart-drawer__saved-option';
      labelText.textContent = definition.name + ':';
      select.setAttribute('data-saved-option-index', String(optionIndex));
      select.setAttribute(
        'aria-label',
        (product.title || product.handle) + ' ' + definition.name
      );

      definition.values.forEach(function(value) {
        var option = document.createElement('option');
        option.value = value;
        option.textContent = value;
        option.selected = defaultOptions[optionIndex] === value;
        select.appendChild(option);
      });

      label.appendChild(labelText);
      label.appendChild(select);
      options.appendChild(label);
    });

    addButton.type = 'button';
    addButton.className = 'cart-drawer__saved-add';
    addButton.setAttribute('data-saved-add', '');

    status.className = 'cart-drawer__saved-status';
    status.setAttribute('data-saved-status', '');
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');

    info.appendChild(titleLink);
    info.appendChild(price);
    info.appendChild(options);
    info.appendChild(addButton);
    info.appendChild(status);

    item.appendChild(media);
    item.appendChild(info);

    Array.prototype.forEach.call(
      options.querySelectorAll('select'),
      function(select) {
        select.addEventListener('change', function() {
          updateSavedVariant(item, product, moneyFormat);
        });
      }
    );

    updateSavedVariant(item, product, moneyFormat);

    return item;
  }

  function updateSavedCount(count) {
    Array.prototype.forEach.call(
      document.querySelectorAll('[data-saved-drawer-count]'),
      function(element) {
        element.textContent = String(count);
      }
    );
  }

  function renderSavedDrawer(favorites) {
    var drawer = document.querySelector('[data-cart-drawer]');
    var list = drawer && drawer.querySelector('[data-saved-drawer-items]');

    if (!drawer || !list) {
      return;
    }

    var currentRenderId = ++drawerRenderId;
    var currentFavorites = normalizeFavorites(favorites || getFavorites());
    var rootUrl = getRootUrl(drawer);
    var moneyFormat =
      drawer.getAttribute('data-money-format') || '${{amount}}';

    updateSavedCount(currentFavorites.length);
    list.innerHTML = '';

    if (currentFavorites.length === 0) {
      var empty = document.createElement('p');
      empty.className = 'cart-drawer__saved-empty';
      empty.textContent = 'No saved items.';
      list.appendChild(empty);
      return;
    }

    var loading = document.createElement('p');
    loading.className = 'cart-drawer__loading';
    loading.textContent = 'Loading...';
    list.appendChild(loading);

    Promise.all(
      currentFavorites.map(function(handle) {
        return fetchProduct(handle, rootUrl);
      })
    ).then(function(products) {
      if (currentRenderId !== drawerRenderId) {
        return;
      }

      var availableProducts = products.filter(function(product) {
        return product && product.handle;
      });

      list.innerHTML = '';
      updateSavedCount(availableProducts.length);

      availableProducts.forEach(function(product) {
        list.appendChild(
          buildSavedDrawerItem(
            product,
            drawer,
            rootUrl,
            moneyFormat,
            currentFavorites
          )
        );
      });

      if (availableProducts.length === 0) {
        var unavailable = document.createElement('p');
        unavailable.className = 'cart-drawer__saved-empty';
        unavailable.textContent = 'No saved items.';
        list.appendChild(unavailable);
      }
    });
  }

  function addSavedItemToCart(button) {
    var drawer = button.closest('[data-cart-drawer]');
    var item = button.closest('[data-saved-item]');
    var status = item && item.querySelector('[data-saved-status]');
    var variantId = button.getAttribute('data-variant-id');
    var comingSoon =
      button.getAttribute('data-coming-soon') === 'true';
    var addUrl =
      (drawer && drawer.getAttribute('data-cart-add-url')) || '/cart/add.js';
    var originalText = button.textContent;

    if (!variantId || button.disabled || comingSoon) {
      return;
    }

    button.disabled = true;
    button.textContent = 'ADDING...';
    if (status) {
      status.textContent = '';
    }

    window
      .fetch(addUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: [
            {
              id: Number(variantId),
              quantity: 1
            }
          ]
        })
      })
      .then(function(response) {
        if (!response.ok) {
          return response.json().then(function(error) {
            throw error;
          });
        }

        return response.json();
      })
      .then(function() {
        button.textContent = 'ADDED';
        if (status) {
          status.textContent = 'Added to bag.';
        }

        if (
          window.theme &&
          window.theme.cartDrawer &&
          typeof window.theme.cartDrawer.refresh === 'function'
        ) {
          window.theme.cartDrawer.refresh(false);
        }

        window.setTimeout(function() {
          button.disabled = false;
          button.textContent = originalText;
        }, 900);
      })
      .catch(function(error) {
        button.disabled = false;
        button.textContent = originalText;
        if (status) {
          status.textContent =
            (error && (error.description || error.message)) ||
            'Unable to add this item.';
        }
      });
  }

  function initializeFavorites() {
    var favorites = getFavorites();

    document.body.classList.toggle(
      'is-saved-view',
      window.location.hash === '#FavoritesSection'
    );

    updateButtons(favorites);
    updateHeaderFavoriteCount(favorites);
    renderCartFavorites(favorites);
    renderSavedDrawer(favorites);
  }

  document.addEventListener(
    'click',
    function(event) {
      var button = event.target.closest(BUTTON_SELECTOR);

      if (!button) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      var handle = button.getAttribute('data-product-handle');
      if (handle) {
        toggleFavorite(handle);
      }
    },
    true
  );

  document.addEventListener('click', function(event) {
    var addButton = event.target.closest('[data-saved-add]');

    if (!addButton) {
      return;
    }

    event.preventDefault();
    addSavedItemToCart(addButton);
  });

  document.addEventListener(CHANGE_EVENT, function(event) {
    var favorites = normalizeFavorites(
      event.detail && event.detail.favorites
    );
    updateButtons(favorites);
    updateHeaderFavoriteCount(favorites);
    renderCartFavorites(favorites);
    renderSavedDrawer(favorites);
  });

  document.addEventListener(SAVED_VIEW_EVENT, function() {
    renderSavedDrawer(getFavorites());
  });

  window.addEventListener('storage', function(event) {
    if (event.key === STORAGE_KEY) {
      initializeFavorites();
    }
  });

  window.addEventListener('hashchange', initializeFavorites);

  document.addEventListener(
    'shopify:section:load',
    initializeFavorites
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeFavorites);
  } else {
    initializeFavorites();
  }
})();
